import React from "react";
import { Row, Col, Button, Spin, Form } from "antd";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export default function EditCards({
  deck,
  onRemoveCardClick,
  loading,
  onFileUpload,
}) {
  const onChange = (info) => {
    if (info.file.status === "done") {
      onFileUpload(info.file.originFileObj);
    } else if (info.file.status === "error") {
      onFileUpload(info.file.originFileObj);
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row
          style={{
            marginTop: 20,
            height: 150,
            justifyContent: "space-between",
          }}
        >
          {deck &&
            deck.map((item, index) => (
              <Col key={index}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    alt={item}
                    className="cardThumbnail"
                    src={item.imageUrl}
                  />
                  <Button
                    onClick
                    style={{ textAlign: "center" }}
                    onClick={() => onRemoveCardClick(index)}
                    type="danger"
                  >
                    Remove
                  </Button>
                </div>
              </Col>
            ))}

          <Col
            className="gutter-row"
            span={4}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {deck.sliders === undefined || deck.sliders.length < 3 ? (
              <Upload
                accept="image/gif, image/jpeg, image/png"
                multiple={false}
                showUploadList={false}
                onChange={onChange}
              >
                <Button style={{ height: 50, width: 50 }}>
                  <PlusOutlined />
                </Button>
              </Upload>
            ) : (
              <div style={{ width: 100 }} />
            )}
          </Col>
        </Row>
        <Row>
          <div className="clearfix"></div>
        </Row>
      </Spin>
    </div>
  );
}
